import $ from 'jquery';

import * as loadingSpinner from '../../images/loading-spinner.png';
import * as lockedPadlock from '../../images/locked-padlock.svg';
import * as thumbsUp from '../../images/thumbs-up-solid.svg';

export default class {
    constructor(resourceType) {
        // configured values and DOM nodes
        this.apiUrl = window._env.config.apiUrl;
        this.url = window._env.config.url;
        this.$browseWrapper = $('.browse-wrapper');

        // private variables
        this.loading = false;
        this.page = 2;
        this.resourceType = resourceType;

        this.init();
    }

    init() {


        // Handle mealplan length select
        $('#mealplanLengthSelect').on('input', function(){
			var newVal = $(this).val();
			if (newVal == 7) {
				$('#mealplanLength').html('7+');
				} else {
					$('#mealplanLength').html($(this).val());
				}
            
        });

        this.$browseWrapper.append(`${this.loadingIndicator()}`);

        const {apiUrl} = this;

        const scrollHandle = {
            allow: true,
            delay: 400,
            reallow() {
                scrollHandle.allow = true;
            },
        };

        $(window).scroll(() => {
            if (!this.loading && scrollHandle.allow) {
                scrollHandle.allow = false;

                setTimeout(scrollHandle.reallow, scrollHandle.delay);

                if ($(document).height() - ($(window).scrollTop() + $(window).height()) <= 1200) {
                    this.loading = true;
                    $('.load-more').addClass('loading');

                    const data = {
                        page: this.page,
                        query: this.getUrlParams(decodeURIComponent(window.location.href)
                            .replace('+', ' ')),
                    };

                    $.ajax({
                        type: 'POST',
                        url: `${apiUrl}${this.resourceType}`,
                        data: JSON.stringify(data),
                        contentType: 'application/json; charset=utf-8',
                        dataType: 'json',
                        success: (data) => {
                            JSON.parse(data)
                                .forEach(resource => {
                                    if (this.resourceType === 'recipes') {
                                        this.appendRecipe(resource);
                                    } else {
                                        this.appendMealPlan(resource);
                                    }
                                });

                            this.page++;
                            jQuery('.load-more').remove()

                            if (!JSON.parse(data).length <= 0) {
                                this.$browseWrapper.append(`${this.loadingIndicator()}`);
                            }

                            this.loading = false;
                        },
                        error: (error) => {
                            console.error(error);
                        },
                    });

                }
            }
        });
    }

    getUrlParams(urlOrQueryString) {
        let i;

        if ((i = urlOrQueryString.indexOf('?')) >= 0) {
            const queryString = urlOrQueryString.substring(i + 1);
            if (queryString) {
                const query = this._mapUrlParams(queryString);

                return query;
            }
        }

        return {};
    }

    // used to create a query object based off strings
    _mapUrlParams(queryString) {
        return queryString
            .split('&')
            .map(function (keyValueString) {
                return keyValueString.split('=')
            })
            .reduce(function (urlParams, [key, value]) {

                // this matches keys and makes them humanreadable and match the keys used by acf
                const humanizedKey = key.replace(/[^a-zA-Z0-9]/g, '');

                if (Number.isInteger(parseInt(value)) && parseInt(value) == value) {
                    urlParams[humanizedKey] = [parseInt(value)];
                } else if (urlParams[humanizedKey] && Array.isArray(urlParams[humanizedKey]) && urlParams[humanizedKey].length > 0) {
                    urlParams[humanizedKey].push(decodeURI(value));
                } else {
                    urlParams[humanizedKey] = [decodeURI(value)];
                }
                return urlParams;
            }, {});
    }

    appendRecipe(recipe) {
        const {$browseWrapper, renderResourceDetails} = this;

        $browseWrapper
            .append(`
      <div class="col-md-4 col-sm-6 col-xs-12 p-2">
          <div class='browse-single'>
              <a href=${recipe.guid}>
                  <img src="${recipe.image[0]}" class="img-fluid">
              </a>
              ${renderResourceDetails(recipe, false)}
          </div>
      </div>
    `)
    }

    appendMealPlan(mealPlan) {
        const {$browseWrapper, renderMultipleImages, renderResourceDetails} = this;

        const hasMultipleImages = mealPlan.image && mealPlan.image.length > 1;

        $browseWrapper.append(`
            <div class="col-md-4 col-sm-6 col-xs-12 p-2">
                <div class="browse-single">
                    ${hasMultipleImages ? `${
            renderMultipleImages(mealPlan.guid, mealPlan.ID, mealPlan.image)
            }` : `
                    <a href="${mealPlan.guid}">
                        <img src="${mealPlan.image[0].photo}" class="img-fluid">
                    </a>`}
                    ${renderResourceDetails(mealPlan, true)}
                </div>
            </div>
        `);
    }

    loadingIndicator() {
        return `<div class="col-sm-12 load-more text-center">
                <img src="${loadingSpinner}" alt="">
          </div>
    `
    }

    renderMultipleImages(guid, id, images) {
        return `
            <div id="Controls-${id}" class="carousel slide" data-ride="carousel" data-interval="false">
              <div class="carousel-inner">
                ${images.map((image, i) => {
            return `
                        <div class="carousel-item ${i == 0 ? 'active' : ''}" data-interval="false">
                            <div>
                              <a href="${guid}">
                                <img src="${image.photo}" class="d-block w-100" alt="${image.photo}">
                              </a>
                            </div>
                        </div>`
        })}
              <ol class="carousel-indicators d-flex align-items-center">
                ${images.map((image, i) => {
            return `<li data-target="#Controls-${id}"
                      data-slide-to="${i}"
                      class="${i == 0 ? 'active' : ''}"></li>`
        })}
              </ol>                
            </div>
        `
    }

    renderResourceDetails(resource, isMealPlan) {
		return `
            <div class="col-sm-12 browse-single-info">
                <div class="row mb-1 mt-1">
                    <div class="col-sm">
                        ${isMealPlan ? `
                            <span class="browse-category-meal-plans">Meal Plan</span>
                        ` : `
                            <span class="browse-category-recipes">Recipe</span>
                        `}
                    </div>
                    <div class="col-sm text-right">
                        ${resource.should_show_liked_percentage ? `
                            <span class='percentage'>${resource.like_percentage}</span>
                            <img class='thumbs-up' src="${thumbsUp}" alt="">` : ''}
                        ${resource.is_locked_content ? `
                            <img class='locked' src="${lockedPadlock}" alt="">` : ''}                    
                        </div>                    
                    </div>
                <div class='row'>
                    <div class='col-sm-12'>
                        <a href="${resource.guid}">
                            <h5>${resource.post_title}</h5>
                        </a>
                    </div>
                </div>                    
            </div>
`
    }
}


// WEBPACK FOOTER //
// ./scripts/modules/BrowseController.js